let discoverySetIndex = 0;

const showRemoveIcon = () => {
  // mkayal -- Defining variables to use them in the discovery set.
  let giftBoxButtonArr = [];
  let BoxButtonElement = $(".box-remove-btn");
  BoxButtonElement.each(function () {
    giftBoxButtonArr.push(this);
  });
  giftBoxButtonArr[discoverySetIndex].style.display = "block";
  discoverySetIndex += 1;
};

$(function () {
  window.prettyPrint && prettyPrint();
  $(document).on("click", ".yamm .dropdown-menu", function (e) {
    e.stopPropagation();
  });
});

var productThumbs = new Swiper(".swiper-container.product-thumbs", {
  slidesPerView: 3,
  loop: true,
  loopedSlides: 5, //looped slides should be the same
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});
var productSlider = new Swiper(".swiper-container.product-slider", {
  autoplay: {
    delay: 5000,
  },
  spaceBetween: 10,
  loop: true,
  loopedSlides: 5, //looped slides should be the same
  thumbs: {
    swiper: productThumbs,
  },
});

var homeGiftDiscoveryMobile = new Swiper(
  "#home-gift-dicovery-mobile .swiper-container",
  {
    loop: true,
    navigation: {
      nextEl: "#home-gift-dicovery-mobile .swiper-button-next",
      prevEl: "#home-gift-dicovery-mobile .swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination-home-gift-dicovery-mobile",
    },
  }
);

function goToProductImage(index) {
  productSlider.slideTo(index - 1, 500, false);
}

var homeProduct = new Swiper("#home-products .swiper-container", {
  scrollbar: {
    el: "#git-fragrances .swiper-scrollbar",
    hide: false,
  },
  navigation: {
    nextEl: "#home-products .swiper-button-next",
    prevEl: "#home-products .swiper-button-prev",
  },
  slidesPerView: 5,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-product-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: 5,
    },
    // when window width is <= 480px
    575: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    // when window width is <= 640px
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    991: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    1100: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
  },
});

var giftSwiper = new Swiper("#git-fragrances .swiper-container.gift", {
  scrollbar: {
    el: "#git-fragrances .swiper-scrollbar",
    hide: false,
  },
  navigation: {
    nextEl: "#git-fragrances .swiper-button-next",
    prevEl: "#git-fragrances .swiper-button-prev",
  },
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-gift-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  on: {
    init: function () {
      $(this.wrapperEl).closest(".collapse-block").addClass("collapse");
    },
  },
  breakpoints: {
    300: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is <= 640px
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1100: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var giftSwiper = new Swiper("#gift-refill .swiper-container.gift", {
  scrollbar: {
    el: "#gift-refill .swiper-scrollbar",
    hide: false,
  },
  navigation: {
    nextEl: "#gift-refill .swiper-button-next",
    prevEl: "#gift-refill .swiper-button-prev",
  },
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-gift-refill-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  on: {
    init: function () {
      $(this.wrapperEl).closest(".collapse-block").addClass("collapse");
    },
  },
  breakpoints: {
    300: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is <= 640px
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1100: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var giftSwiper1 = new Swiper("#collapseTwo1 .swiper-container", {
  scrollbar: {
    el: "#collapseTwo1 .swiper-scrollbar",
    hide: false,
  },
  navigation: {
    nextEl: "#collapseTwo1 .swiper-button-next",
    prevEl: "#collapseTwo1 .swiper-button-prev",
  },
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-gift1-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  on: {
    init: function () {
      $(this.wrapperEl).closest(".collapse-block").addClass("collapse");
    },
  },
  breakpoints: {
    300: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is <= 640px
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1100: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var giftSwiper0 = new Swiper("#collapseTwo21 .swiper-container.gift", {
  scrollbar: {
    el: "#collapseTwo21 .swiper-scrollbar",
    hide: false,
  },
  navigation: {
    nextEl: "#collapseTwo21 .swiper-button-next",
    prevEl: "#collapseTwo21 .swiper-button-prev",
  },
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: "#collapseTwo21 .swiper-gift0-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  on: {
    init: function () {
      $(this.wrapperEl).closest(".collapse-block").addClass("collapse");
    },
  },
  breakpoints: {
    300: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is <= 640px
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1100: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var giftSwiper2 = new Swiper("#collapseThree31 .swiper-container", {
  scrollbar: {
    el: "#collapseThree31 .swiper-scrollbar",
    hide: false,
  },
  navigation: {
    nextEl: "#collapseThree31 .swiper-button-next",
    prevEl: "#collapseThree31 .swiper-button-prev",
  },
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: "#collapseThree31 .swiper-gift2-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  on: {
    init: function () {
      $(this.wrapperEl).closest(".collapse-block").addClass("collapse");
    },
  },
  breakpoints: {
    300: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is <= 640px
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1100: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var relatedSwiper = new Swiper(".swiper-container.related", {
  navigation: {
    nextEl: "#related-product .swiper-button-next",
    prevEl: "#related-product .swiper-button-prev",
  },
  pagination: {
    el: ".swiper-related-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    300: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    // when window width is <= 640px
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1100: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

var swiperMobileText = new Swiper(".text.swiper-container", {
  pagination: {
    el: ".text.swiper-pagination",
  },
});

$("#collapseThree31.collapse-block").removeClass("show");

// Focus to search input when search modal shown
$("#searchModal").on("shown.bs.modal", () => {
  searchInput.focus();
});

// cart
function deleteItem(index) {
  var link = "/cart/change?line=" + index + "&amp;quantity=0";
  $(location).attr("href", link);
}

// Gift Box
function addGiftBox(t) {
  const product = getProduct(t);
  const bottle = availableBottle(product.collection);

  if (bottle) {
    $(`#bottle_${bottle} img.product`).attr("src", product.image);
    $(`#bottle_${bottle} .title`).text(product.title);
    $(`#bottle_${bottle} .product_id`).val(product.id);
    $(`#bottle_${bottle} .price`).val(product.price);
    $(`#bottle_${bottle} .variant_id`).val(product.variantId);
    $(`#bottle_${bottle} input.empty`).val("false");
    $(t).hide();
    $(t).next(".remove-from-gift").show();
  }
  disableAddBtn();
  setTotalPrice();
}

function availableBottle(collection) {
  const bottles = getBottle();
  if (
    collection === "refill" &&
    !bottles.find((x) => x.collection === "refill").productId
  ) {
    return 3;
  }
  for (let bottle of bottles) {
    if (!bottle.productId && bottle.collection === "any") {
      return bottle.index;
    }
  }
  return false;
}

function removeGiftBox(t) {
  const bottles = getBottle();
  const product = getProduct(t);
  const toDelete = bottles.find((x) => x.productId === product.id);
  resetGiftBox(toDelete.index);
  $(t).hide();
  $(t).prev(".add-to-gift").show();
  disableAddBtn();
  setTotalPrice();
}

function resetGiftBox(index) {
  const bottle = $("#bottle_" + index);
  let image =
    "https://cdn.shopify.com/s/files/1/0407/4985/8982/files/blank_bottle.png?v=1601137681";
  if (index === "3") {
    image =
      "https://cdn.shopify.com/s/files/1/0407/4985/8982/files/blank_refill.png?v=1601155824";
  }
  $(`#bottle_${index} img.product`).attr("src", image);
  $(`#bottle_${index} .title`).text("");
  $(`#bottle_${index} .product_id`).val("");
  $(`#bottle_${index} input.empty`).val("ture");
}

function getBottle() {
  let bottles = [];
  for (let i = 1; i < 4; i++) {
    const bottle = {
      productId: $(`#bottle_${i} input.product_id`).val(),
      variantId: $(`#bottle_${i} input.variant_id`).val(),
      collection: $(`#bottle_${i} input.collection`).val(),
      index: $(`#bottle_${i} input.index`).val(),
      price: parseInt($(`#bottle_${i} input.price`).val()),
    };
    bottles.push(bottle);
  }
  return bottles;
}

function getProduct(t) {
  const productEl = $(t).closest(".product-card");
  var product = {
    title: productEl.find(".title")[0].text,
    image: productEl.find("img.product")[0].src,
    collection: productEl.find("input.collection")[0].value,
    id: productEl.find("input.product_id").val(),
    price: parseInt(productEl.find("input.price").val()),
    variantId: productEl.find("input.variant_id").val(),
  };
  return product;
}

function disableAddBtn() {
  if (availableBottle()) {
    $(".add-to-gift").attr("disabled", false);
  } else {
    $(".add-to-gift").attr("disabled", true);
  }
  if (availableBottle("refill")) {
    $(".add-to-gift.refill").attr("disabled", false);
  } else {
    $(".add-to-gift.refill").attr("disabled", true);
  }
}

function setTotalPrice() {
  const gifts = getGiftBox();
  const bottles = getBottle();
  let total = 0;
  for (let b of bottles) {
    if (b.productId) {
      total = total + b.price;
    }
  }
  if (total === 0) {
    $("#add-to-cart").attr("disabled", true);
    $("#add-to-cart > span").text("");
    $("#add-to-cart > span").hide();
    $("p#size").hide();
  } else {
    total += gifts.price;
    $("#add-to-cart").attr("disabled", false);
    $("#add-to-cart > span").text(total + "€");
    $("p#size").show();
    $("#add-to-cart > span").show();
    $("p#size > span").text(bottles.filter((x) => x.productId).length);
  }
}

function getGiftBox() {
  return {
    id: $("#gift-box input.product_id").val(),
    price: parseInt($("#gift-box input.price").val()),
  };
}

// Discovery sets
function disableSetsAddBtn() {
  if (availableSets()) {
    $(".add-to-gift").attr("disabled", false);
  } else {
    $(".add-to-gift").attr("disabled", true);
  }
}

function addSet(t) {
  const product = getProduct(t);
  const bottle = availableSets();

  if (bottle) {
    $(`#bottle_${bottle} img.product`).attr("src", product.image);
    $(`#bottle_${bottle} .title`).text(product.title);
    $(`#bottle_${bottle} .product_id`).val(product.id);
    $(`#bottle_${bottle} .price`).val(product.price);
    $(`#bottle_${bottle} .variant_id`).val(product.variantId);
    $(`#bottle_${bottle} input.empty`).val("false");
    $(t).hide();
    $(t).next(".remove-from-gift").show();
    $(this).find(".card-body .remove-from-gift").show();
  }
  disableSetsAddBtn();
  enableSetsAddToCard();

  //HM
}

function availableSets() {
  const bottles = getSets();
  for (let bottle of bottles) {
    if (!bottle.productId) {
      return parseInt(bottle.index);
    }
  }
  return false;
}

function removeSet(t) {
  const bottles = getSets();
  const product = getProduct(t);
  const toDelete = bottles.find((x) => x.productId === product.id);
  resetSets(toDelete.index);
  $(t).hide();
  $(t).prev(".add-to-gift").show();
  // $(t).next('.remove-from-gift').hide();
  disableSetsAddBtn();
  enableSetsAddToCard();
}

function resetSets(index) {
  const bottle = $("#bottle_" + index);
  let image =
    "https://cdn.shopify.com/s/files/1/0407/4985/8982/files/refill_blank.jpg?v=1602345958";
  $(`#bottle_${index} img.product`).attr("src", image);
  $(`#bottle_${index} .title`).text("");
  $(`#bottle_${index} .product_id`).val("");
  $(`#bottle_${index} input.empty`).val("ture");
}

function getSets() {
  let bottles = [];
  for (let i = 1; i < 6; i++) {
    const bottle = {
      productId: $(`#bottle_${i} input.product_id`).val(),
      variantId: $(`#bottle_${i} input.variant_id`).val(),
      index: $(`#bottle_${i} input.index`).val(),
      price: parseInt($(`#bottle_${i} input.price`).val()),
    };
    bottles.push(bottle);
  }
  return bottles;
}

function getGiftBox() {
  return {
    id: $("#gift-box input.product_id").val(),
    price: parseInt($("#gift-box input.price").val()),
  };
}

function enableSetsAddToCard() {
  if (getSets().filter((x) => x.productId).length === 5) {
    $("#add-to-cart").attr("disabled", false);
  } else {
    $("#add-to-cart").attr("disabled", true);
  }
}

// loading model
$(document).ready(function () {
  $("#loading").modal({
    show: false,
    backdrop: "static",
  });
});

function showLoading() {
  $("#loading").modal("show");
}

function hideLoading() {
  $("#loading").modal("hide");
}

///////////////// fixed menu on scroll for desktop
$(window).scroll(function () {
  if ($(this).scrollTop() > 127) {
    $("#header").addClass("sticky-nav");
    // add padding top to show content behind navbar
    $("#PageContainer").css("padding-top", $(".navbar").outerHeight() + "px");
  } else {
    $("#header").removeClass("sticky-nav");
    // remove padding top from body
    $("#PageContainer").css("padding-top", "0");
  }
});

//HM open the mobile gift box just once
$(".btn.add-to-gift").on("click", function () {
  maximizeGift();
  $(".btn.add-to-gift").off("click");
}); //end

function maximizeGift() {
  $("#box-include").removeClass("minimize");
}

function toggleMinimizeGift() {
  $("#box-include").toggleClass("minimize");
}

let boxFixed = 1500;
$(document).ready(function () {
  if (document.getElementById("box-include")) {
    boxFixed =
      document.getElementById("MainContent").clientHeight -
      document.getElementById("box-include").clientHeight +
      600;
  }
});
$(window).scroll(function () {
  if ($(this).scrollTop() > boxFixed) {
    $("#box-include").removeClass("fixed");
  } else {
    $("#box-include").addClass("fixed");
  }
});

$("#mobileSearch").focus(function () {
  $("#slide-out").addClass("search-focus");
});
$("#mobileSearch").focusout(function () {
  $("#slide-out").removeClass("search-focus");
});

$(document).ready(function () {
  var megaI = false;

  $("nav .dropdown").hover(
    function () {
      $(this).find($(".dropdown-menu.mega-menu").show());
    },
    function () {
      $(this).find($(".dropdown-menu.mega-menu").hide());
    }
  );

  $("li.fade").hover(function () {
    $(this).fadeOut(100);
    $(this).fadeIn(500);
  });
});

//console.log("site");

//hidden message display
if ($(window).width() > 1024) {
  //console.log("SCREEN IS MORE THAN 1024!");

  if ($("#product-page").hasClass("sweet-ambrette")) {
    $("#lightgallery img").hover(
      function () {
        $("#product-page .hiddenMessage").fadeIn(100);
      },
      function () {
        $("#product-page .hiddenMessage").fadeOut(100);
      }
    );
  }
}

if (screen.width < 1024) {
  $("#product-page").addClass("hiddenmMessageSmallScreen");

  //console.log("SCREEN IS LESS THAN 1024!");

  if (
    $("#product-page").hasClass("sweet-ambrette") &&
    $("#product-page").hasClass("hiddenmMessageSmallScreen")
  ) {
    $("#lightgallery img").on("click", function () {
      //console.log("B4 TOGGLE");

      $("#product-page .hiddenMessage").toggle();
      //console.log("AFTER TOGGLE");
    });
  }
}

//change laguage to french

var str = $("#language-menu .dropdown button");
if (str.text() == " fr ") {
  $("#subscribe .social-icon .link-facebook").attr(
    "href",
    "https://www.facebook.com/majourifragrances/#"
  );

  $("#mobileSearch").attr("placeholder", "Rechercher");
  $("#slide-out .collapsible li a:contains(HOME)").text("ACCUEIL");
  // chnging lang. to french in he navbar images
  $(".card-body .card-text, i").each(function () {
    if ($(this).text() == "For Him") {
      $(this).text("Pour Lui");
    } else if ($(this).text() == "For Her") {
      $(this).text("Pour Elle");
    } else if ($(this).text() == "Unisex") {
      $(this).text("Unisexe");
    } else if ($(this).text() == "Woody Fruity") {
      $(this).text("Boisé Fruité");
    } else if ($(this).text() == "Oriental Woody") {
      $(this).text("Boisé Oriental");
    } else if ($(this).text() == "Woody Spicy") {
      $(this).text("Boisé Épicé");
    } else if ($(this).text() == "Oriental Spicy") {
      $(this).text("Épicé Oriental");
    } else if ($(this).text() == "Oriental Spicy") {
      $(this).text("Épicé Oriental");
    } else if ($(this).text() == "JOUR 5") {
      $(this).text("Musqué Floral Boisé");
    }
  });

  // IN PRODUCT PAGE CHANGING LANG. FOR HIM/HER/UNISEX

  $("#product-page #product-detiles span , i, li").each(function () {
    if ($(this).text() == "For Him") {
      $(this).text("Pour Lui");
    } else if ($(this).text() == "For Her") {
      $(this).text("Pour Elle");
    } else if ($(this).text() == "Unisex") {
      $(this).text("Unisexe");
    } else if ($(this).text() == "Floral Fruity Gourmand") {
      $(this).text("Floral Fruité Gourmand");
    } else if ($(this).text() == "Chypre Floral") {
      $(this).text("Floral Chypré");
    } else if ($(this).text() == "Floral Fruity") {
      $(this).text("Floral Fruité");
    } else if ($(this).text() == "Woody Citrusy") {
      $(this).text("Boisé d’Agrumes");
    } else if ($(this).text() == "Woody Aromatic") {
      $(this).text("Aromatique Boisé");
    } else if ($(this).text() == "Citrus Spicy Woody") {
      $(this).text("Boisé Épicé d’Agrumes");
    } else if ($(this).text() == "Leather") {
      $(this).text("Cuivrée");
    } else if ($(this).text() == "JOUR 9") {
      $(this).text("Boisé Épicé");
    }
  });

  //changing all the Refill text TO french Lng.
  $("div , a , span").each(function () {
    if ($(this).text() == "Refill") $(this).text("Recharges");
  });

  if ($("#sets-collection-cover h1").text().toUpperCase() == "DISCOVERY SETS") {
    $("#sets-collection-cover h1").text("COFFRETS DÉCOUVERTE");
  }

  var enRemove = $(
    "nav #mega-menu-tab-refill .sub-menu-container .rechargesBefor"
  );

  enRemove.each(function () {
    if ($(this).text() == "Crazy in Love Refill") {
      $(this).text("Recharge Crazy in Love");
    } else if ($(this).text() == "Sayidati Refill") {
      $(this).text("Recharge Sayidati");
    } else if ($(this).text() == "Secret Love Refill") {
      $(this).text("Recharge Secret Love");
    } else if ($(this).text() == "Blue Desert Refill") {
      $(this).text("Recharge Blue Desert");
    } else if ($(this).text() == "Signature Refill") {
      $(this).text("Recharge Signature");
    } else if ($(this).text() == "The One and Only Refill") {
      $(this).text("Recharge The One and Only");
    } else if ($(this).text() == "One of a Kind Refill") {
      $(this).text("Recharge One of a Kind");
    } else if ($(this).text() == "1982 Refill") {
      $(this).text("Recharge 1982");
    } else if ($(this).text() == "Gold Noir Refill") {
      $(this).text("Recharge Gold Noir");
    } else if ($(this).text() == "Oriental Soul Refill") {
      $(this).text("Recharge Oriental Soul");
    } else if ($(this).text() == "Charming Tuberose Refill") {
      $(this).text("Recharge Charming Tuberose");
    } else if ($(this).text() == "White Rose Refill") {
      $(this).text("Recharge White Rose");
    } else if ($(this).text() == "Silky Sandalwood Refill") {
      $(this).text("Recharge Silky Sandalwood");
    } else if ($(this).text() == "Sweet Ambrette Refill") {
      $(this).text("Recharge Sweet Ambrette");
    }
  });
} //end FR changes

//change language to Arabic

if (str.text() == " ar ") {
  console.log("ar exists");

  $(".classic-tabs .nav li a").addClass("text-right");
  $("#description-tab p").addClass("text-right");

  $("#header .ticker-move").css({
    "animation-direction": "reverse",
  });

  $("p").css({
    direction: "rtl",
  });
}
//change language to Turkish

if (str.text() == " tr ") {
  console.log("tr exists");

  $("#subscribe .social-icon .link-facebook").attr(
    "href",
    "https://www.facebook.com/majourifragrances/#"
  );

  $("#subscribe-form button.btn-black").css({
    padding: "0",
  });

  $("p").css({
    direction: "initial",
  });
  $(".collection-cover-genesis-collection .subtitle").text(
    "Doğu'dan Batı'ya Yolculuk"
  );
  $(".collection-cover-quest-collection .subtitle").text("Doğa'nın Özü");
  $(".collection-cover-jour .subtitle").text("En Üstün Parfüm İlhamı");
  $("#p-reviews a").text("YORUMLAR");

  //   Chainging the COLLECTION TO KOLEKTION

  $(".swiper-slide .slider-caption h2").each(function () {
    var sliderWord = $(this).text();
    sliderWord = sliderWord.replace("COLLECTION", "KOLEKSİYONU");
    $(this).text(sliderWord);
  });

  // changing the upper text of Class="main info" to turkish translation

  let upperAlt = $("#product-detiles .main-note").text();
  console.log(upperAlt);

  if (upperAlt.toUpperCase().indexOf("lol") >= 0) {
    console.log("true");
  } else {
    console.log("false");
  }
}

// review
function getReview(id) {
  const reviewUrl = helperUrl + "review/review/" + id;
  $.ajax({
    url: reviewUrl,
    type: "GET",
    success: function (data, textStatus, jqXHR) {
      renderReview(data);
      renderStars(data);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(textStatus);
    },
  });
}
// Render the stars revording to the incoming data, get the star svg from the internet and put it in the average-rating div
// The function should render an empty star if the rating is less than the current star, and a full star if the rating is more than the current star

// Make a function called renderStars that takes data as input, and use the rate attrubute to get the rating of the product
// The rating is between 1 and 5, so we need to loop through the stars and render the correct number of stars
// The rating step is 0.5, thus we need to round the rating to the nearest 0.5
// The function should render an empty star if the rating is less than the current star, and a full star if the rating is more than the current star

function renderStars(data) {
  const stars = document.getElementById("stars-container");
  const emptyStarUrl =
    "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/empty-star.png?v=1643995131";
  const fullStarUrl =
    "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/full-star.png?v=1643995131";
  const halfStarUrl =
    "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/half-star.png?v=1643995131";
  const rating = data.rate;
  const ratingStep = 0.5;
  const roundedRating = Math.round(rating / ratingStep) * ratingStep;
  let starCount = Math.floor(roundedRating);
  let halfStarCount = Math.round((roundedRating - starCount) * 2);
  let emptyStarCount = 5 - starCount - halfStarCount;
  if (data.reviewNumber === 0) {
    starCount = 0;
    emptyStarCount = 5;
  }
  for (let i = 0; i < 5; i++) {
    var imageElement = document.createElement("img");
    if (starCount > 0) {
      imageElement.setAttribute("src", fullStarUrl);
      starCount--;
    } else if (halfStarCount > 0) {
      imageElement.setAttribute("src", halfStarUrl);
      halfStarCount--;
    } else {
      imageElement.setAttribute("src", emptyStarUrl);
      emptyStarCount--;
    }
    imageElement.classList.add("star-avg");
    stars?.appendChild(imageElement);
  }
}

function renderReview(data) {
  if ($(".all-stars").length) {
    const html = `
    <div class="rate readonly get" data-rate-value='${data.rate}' title="${data.rate}"></div>
    <h4><span id="numberofreviews">${data.reviewNumber}</span> ${localizer.reviews}</h4>
    `;
    $(".all-stars").html(html);
  }
  var topReviewNumber = 4;
  if (window.innerWidth < 992) {
    topReviewNumber = 2;
  }
  if (window.innerWidth < 767) {
    topReviewNumber = 1;
  }
  let topReviewsHtml = "";
  let reviewsHtml = "";
  const topReviews = data.comments.slice(0, topReviewNumber);
  const reviews = data.comments.slice(topReviewNumber);
  if (topReviews) {
    topReviews.forEach((e) => {
      topReviewsHtml += getRateHtml(e);
    });
  }
  if (reviews) {
    reviews.forEach((e) => {
      reviewsHtml += getRateHtml(e);
    });
  }
  if ($("#first-review").length) {
    $("#first-review").html(topReviewsHtml);
  } else {
    reviewsHtml += topReviewsHtml;
  }
  //console.log("site");
  $("#reviews > .list").html(reviewsHtml);
  rateInit();
}

function getRateHtml(review) {
  if (review != null) {
    var currentLocal = Shopify.locale;

    var reviewDateTag = `<h6 class="review-date">${review.date ? review.date : ""
      }</h6>`;
    var reviewTitleTag = review.title ? `<h4>${review.title}</h4>` : "";

    return `
    <div class="swiper-slide d-flex flex-column mb-3">
      <div class="d-inline-flex px-3 pb-2">
        <div class="rounded-circle review-avatar mr-1">
          ${review.name.charAt(0).toUpperCase()}
          <span class="position-absolute badge rounded-pill text-white review-avatar-badge">
            &#x2713;
          </span>
        </div>
        <div class="row">
          <div class="d-inline ${review.date ? "col-3" : "col"} mx-1">
            <div class="rate readonly get" data-rate-value='${review.rate
      }'></div>
          </div>
          <div class="col mx-1">
            ${reviewDateTag}
          </div>
          <div class="w-100"></div>
          <div class="col d-flex">
            <div class="bg_black mx-1 d-flex align-items-center">
              <h6 class="verify-badge text-white my-0">${currentLocal === "fr" ? "Vérifié" : "Verified"
      }</h6>
            </div>
            <div class="mx-1 d-flex align-items-center">
              <h6 class="review_author my-0">${review.name}</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="d-inline-flex">
        <div class="col">
          ${reviewTitleTag}
          <p class="review_comment">${review.comment}</p>
        </div>
      </div>      
    </div>
    `;
  }
  return "";
}

// Rate
$(document).ready(function () {
  var rateReadonlyOptions = {
    step_size: 0.5,
    readonly: true,
  };
  $(".rate.readonly").rate(rateReadonlyOptions);
});

function rateInit() {
  var rateReadonlyOptions = {
    step_size: 0.5,
    readonly: true,
    selected_symbol_type: "image",
    symbols: {
      image: {
        base: '<div class="star-bg">&nbsp;</div>',
        hover: '<div class="star-bg">&nbsp;</div>',
        selected: '<div class="star-bg">&nbsp;</div>',
      },
    },
  };
  $(".rate.readonly.get").rate(rateReadonlyOptions);
}
$(document).ready(function () {
  if ($("#review-handle").length) {
    getReview($("#review-handle").val());
  }
});

// Raterjs
$(document).ready(function () {
  var options = {
    selected_symbol_type: "image",
    symbols: {
      image: {
        base: '<div class="star-bg">&nbsp;</div>',
        hover: '<div class="star-bg">&nbsp;</div>',
        selected: '<div class="star-bg">&nbsp;</div>',
      },
    },
    max_value: 5,
    step_size: 0.5,
    update_input_field_name: $("#rate-input"),
  };
  $(".rate-input").rate(options);
});

$("#comment").focus(function () {
  $(".rate-input").css("opacity", "1");
});

$("#post-review").click(function () {
  $(".comment-form").addClass("loading");
  const comment = $("#comment").val();
  const handle = $("#review-handle").val();
  const customer = $("#customer-name").val();
  const rate = parseFloat($("#rate-input").val());
  const languageInput = $("#language-input").val();
  const brand = $("#brand").val();
  const productId = $("#product-id").val();
  if (comment.length > 2) {
    $("#comment").removeClass("invalid");
    let data = {
      comment: comment,
      rate: rate,
      name: customer,
      handle: handle,
      language: languageInput,
      brand: brand,
      productId: productId,
    };
    const url = helperUrl + "review/review/";
    $.ajax({
      type: "POST",
      url: url,
      data: JSON.stringify(data),
      contentType: "application/json",
      dataType: "JSON",
      success: function (data, textStatus, jQxhr) {
        toastr.success("Merci beaucoup");
        $(".comment-form").removeClass("loading");
        $("#comment").val("");
      },
      error: function (jqXhr, textStatus, errorThrown) {
        console.log(errorThrown);
        $(".comment-form").removeClass("loading");
      },
    });
  } else {
    toastr.error("Veuillez saisir le commentaire");
    $("#comment").addClass("invalid");
    $(".comment-form").removeClass("loading");
  }
});
const preview = localStorage.getItem("preview");
if (preview) {
  $(".preview").removeClass("d-none");
}

var Days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // index => month [0-11]
var option = '<option value="day">DAY</option>';
var selectedDay = "day";
for (var i = 1; i <= Days[0]; i++) {
  //add option days
  option += '<option value="' + i + '">' + i + "</option>";
}
$("#day").append(option);
$("#day").val(selectedDay);

var option = '<option value="month">MONTH</option>';
var selectedMon = "month";
for (var i = 1; i <= 12; i++) {
  option += '<option value="' + i + '">' + i + "</option>";
}
$("#month").append(option);
$("#month").val(selectedMon);

// MKayal
// Defining a function to get the product Ingredients (photos) to display them in the notes tab
function getProductIngredients(
  productName,
  ingredientsList,
  notesDescription,
  ingredientsDescription,
  notesDescriptionHeader = null
) {
  const ingredientsData = {
    // JSON object, modified manually, the resources are given from MJ team (The following are the links in the shopify admin files)

    lemon:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/lemon_14a1f11b-b418-443a-90fe-2ee2b5d17179.png?v=1674401207",
    "ylang-ylang":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/ylang_ylang_31544c4e-ccff-4d27-993b-a1c9e2270f26.png?v=1674401206",
    vetiver:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/vetiver_912eb130-16f3-47cd-8535-5e160d14a1b8.png?v=1674401207",
    bergamot:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/bergamot.png?v=1674401207",
    neroli:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/neroli_7300031e-76f6-46fa-ad4e-faf1634d90af.png?v=1674401207",
    "guaiac-wood":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/guaix_wood.png?v=1674401207",
    "pink-berries":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/pink_berries_e8b128d5-f321-4e95-9b88-c94741f2c66a.jpg?v=1640089911",
    myrrh:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/myrrh.png?v=1674401206",
    "lily-of-the-valley":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/lily_of_the_valley_8d7d2211-96f2-4b3e-8239-3e94fb29842b.jpg?v=1640089911",
    "cedar-wood":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/cedarwood_2022abce-8c0c-4683-8a62-a2567ffd285d.png?v=1636708076",
    lavender:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/lavender.png?v=1674401206",
    ginger:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/ginger_a8ab02c9-68e1-497d-a1bf-34c71922b1e6.jpg?v=1640089911",
    "sandal-wood":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/sandalwood.png?v=1636708075",
    jasmine:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/jasmine.png?v=1674401206",
    patchouli:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/patchouli_64537af9-a92c-4a62-9458-378ea6fbc6a0.png?v=1674401207",
    blackberry:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/blackberry.png?v=1636708075",
    freesia:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/freesia.png?v=1674401207",
    kiwi: "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/kiwi_3b1abf67-1e6d-4d8e-8bec-13df5157c4ac.png?v=1674401207",
    orchid:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/orchid_256aa044-2252-4ea5-9344-77094341a3f4.png?v=1674401208",
    musk: "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/musk.png?v=1674401206",
    basil:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/basil.png?v=1636708075",
    vanilla:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/vanilla_2c636ef9-ade8-4d51-8b4a-a657124b0cb3.png?v=1674401207",
    "agar-wood":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/agarwood.png?v=1636708074",
    cinnamon:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/cinnamon_1.png?v=1636708075",
    amber:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/amber_84f62676-c850-4bc1-a5a8-5be6492e4794.png?v=1674401207",
    rose: "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/rose_ed8feae2-5156-46fc-806a-0a98628e5bc9.jpg?v=1640089911",
    saffron:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/saffron_de840225-e200-44a1-8665-6425fdb1777f.png?v=1674401206",
    leather:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/leather.png?v=1636708075",
    "pink-peppercorn":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/pink_peppercorn_1f4f7592-2f65-4edc-bb83-1098cdd7a5ab.jpg?v=1640089911",
    magnolia:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/magnolia_1.png?v=1636708075",
    osmanthus:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/osmanthus.png?v=1636708075",
    juniper:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/juniper_berries.png?v=1674401206",
    ambrette:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/ambrette_3019067d-2bf1-484c-99e4-fd5b03f0a4aa.png?v=1674401207",
    coconut:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/coconut_243905a4-8394-40c5-8acd-72fc38a7f6fb.png?v=1674401207",
    tuberose:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/tuberose_d453aa25-79ab-4d3b-930d-a31ae367a269.png?v=1674401207",
    tuberose:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/tuberose_d453aa25-79ab-4d3b-930d-a31ae367a269.png?v=1674401207",
    pear: "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/pear_75bf85be-bdd5-4ba4-9594-f764cb51737d.png?v=1674401207",
    "green tea":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/green_tea.png?v=1674401206",
    orris:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/orris_blue_7c2a80a9-ceae-4f8e-9be2-74694b42d40e.png?v=1674401207",
    "petit grain":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/petitgrain_b8e63a62-e541-4f35-883c-dd5432dae8d9.png?v=1674401207",
    vetiver:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/vetiver.png?v=1636708075",
    rosemary:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/rosemary_b1a79efd-b24f-4b51-8973-5d79ac93cefd.png?v=1674401206",
    plum: "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/plum_dc45f056-afa3-47e3-81e2-f5c6b9373d2e.png?v=1674401207",
    tonka:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/tonka_bean.png?v=1674401207",
    "red rose":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/rose_red_82eab83c-8305-4787-830c-2d9af82462ef.png?v=1674401207",
    "orris ":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/orris_violet_eca81a6e-2378-4af2-a818-33124e818b35.png?v=1674401207",
    oud: "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/oud_d9ee1dea-d70b-40e8-b600-d0e17ccae92a.png?v=1674401206",
    violet:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/violet_1c6cf5bd-6c61-4eea-a998-f7542f200d33.png?v=1674401207",
    lychee:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/litchee.png?v=1674401206",
    "white rose":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/rose_white_c16efc66-a6a2-4459-ac3a-50edfdd8945b.png?v=1674401207",
    "black pepper":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/black_pepper_ffe5f828-9085-4d90-b94e-87d1e3713569.png?v=1674401207",
    "cedar wood":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/cedarwood_af2f23f6-6947-40f9-bca5-bf5f5af3613d.png?v=1674401207",
    "rose pink":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/rose_51f34863-9ef1-42bf-806b-b999e6b59953.png?v=1674401206",
    "pink rose":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/rose_51f34863-9ef1-42bf-806b-b999e6b59953.png?v=1674401206",
    "leather ":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/leather_aee20925-a1ed-42ba-87ed-c3e6174378b9.png?v=1674401206",
    "white flowers":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/white_flowers_a17dc6dd-8951-4cd3-b3f7-a6b710517041.png?v=1674401206",
    orange:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/orange.png?v=1674401207",
    "dry wood":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/dry_wood.png?v=1674401207",
    mandarin:
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/mandarin.png?v=1674401207",
    "woody amber":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/Amber-01.jpg?v=1681379566",
    "brown sugar":
      "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/brown_sugar.jpg?v=1726757185",
    sesame: "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/sesame.png?v=1756579630",
    "orange blossom": "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/orange_blossom.png?v=1756579630",
    "white musk": "https://cdn.shopify.com/s/files/1/0017/6436/0239/files/musk.png?v=1674401206",
  };
  const elementsTranslation = {
    mandarin: "MANDARINE",
    "woody amber": "AMBRE BOISÉ",
    "dry wood": "bois sec",
    orange: "orange",
    "white flowers": "Fleurs blanches",
    "leather ": "Cuir",
    "rose pink": "Rose",
    "pink rose": "Rose",
    "cedar wood": "Cèdre",
    "black pepper": "Poivre noir",
    "white rose": "rose blanche",
    violet: "violette",
    oud: "Oud",
    "orris ": "Iris",
    "red rose": "Rose rouge",
    plum: "Prune",
    tonka: "Tonka",
    rosemary: "Romarin",
    "petit grain": "Petit grain",
    vetiver: "Vétiver",
    orris: "Iris",
    lemon: "Citron",
    "ylang-ylang": "Ylang-Ylang",
    vetiver: "Vétiver",
    bergamot: "Bergamote",
    neroli: "Néroli",
    "guaiac-wood": "Bois de Gaïac",
    "pink-berries": "Baie Rose",
    myrrh: "Myrrhe",
    "lily-of-the-valley": "Muguet",
    "cedar-wood": "Cèdre",
    lavender: "Lavande",
    ginger: "gingembre",
    "sandal-wood": "Bois de Santal",
    jasmine: "Jasmin",
    patchouli: "Patchouli",
    blackberry: "Mûre",
    freesia: "Freesia",
    kiwi: "kiwi",
    orchid: "Orchidée",
    musk: "Musc",
    basil: "Basilic",
    vanilla: "vanille",
    "agar-wood": "Bois d'Agar",
    cinnamon: "Cannelle",
    amber: "Ambre",
    rose: "Rose",
    saffron: "Safran",
    leather: "Cuir",
    "pink-peppercorn": "Poivre Rose",
    magnolia: "Magnolia",
    osmanthus: "Osmanthus",
    juniper: "genévrier",
    ambrette: "ambrette",
    coconut: "Noix de coco",
    "tuberose ": "Tubéreuse",
    tuberose: "TUBÉREUSE",
    pear: "Poire",
    "green tea": "Thé vert",
    lychee: "litchi",
    "brown sugar": "cassonade",
    "sesame": "Sésame",
    "orange blossom": "Fleur d'oranger",
    "white musk": "Musc blanc",
  };
  const frenchIngrediantsMap = {
    mandarine: "mandarin",
    "ambre boisé": "woody amber",
    "bois sec": "dry wood",
    orange: "orange",
    "fleurs blanches": "white flowers",
    cuir: "leather",
    rose: "rose",
    "bois de cèdre": "cedar-wood",
    "poivre noir": "black pepper",
    violette: "violet",
    oud: "oud",
    iris: "orris",
    "rose rouge": "red rose",
    prune: "plum",
    tonka: "tonka",
    romarin: "rosemary",
    "petit grain": "petit grain",
    vétiver: "vetiver",
    citron: "lemon",
    "ylang-ylang": "ylang-ylang",
    bergamote: "bergamot",
    néroli: "neroli",
    "bois de gaïac": "guaiac-wood",
    "baie rose": "pink-berries",
    myrrhe: "myrrh",
    muguet: "lily-of-the-valley",
    lavande: "lavender",
    gingembre: "ginger",
    "bois de santal": "sandal-wood",
    jasmin: "jasmine",
    patchouli: "patchouli",
    mûre: "blackberry",
    freesia: "freesia",
    kiwi: "kiwi",
    orchidée: "orchid",
    musc: "musk",
    basilic: "basil",
    vanille: "vanilla",
    "bois d'agar": "agar-wood",
    cannelle: "cinnamon",
    ambre: "amber",
    safran: "saffron",
    "poivre rose": "pink-peppercorn",
    magnolia: "magnolia",
    osmanthus: "osmanthus",
    genévrier: "juniper",
    ambrette: "ambrette",
    "noix de coco": "coconut",
    tubéreuse: "tuberose",
    poire: "pear",
    "thé vert": "green tea",
    litchi: "lychee",
    "rose blanche": "white rose",
    cassonade: "brown sugar",
    sésame: "sesame",
    "fleur d'oranger": "orange blossom",
    "musc blanc": "white musk",
  };

  var language = document.getElementsByTagName("html")[0].getAttribute("lang");

  // Clearing the HTML element
  let mainIngredientContainer = document.getElementById("main-ingredients");
  mainIngredientContainer.innerHTML = "";

  const ingredientsDiv = document.getElementById("ingredients");
  if (!ingredientsDiv) {
    return;
  }
  ingredientsDiv.innerHTML = " ";
  let main_html_element = ``;
  let html_element = `<div class="d-flex col-12 px-4" style="gap: 10px; justify-content: space-evenly;">`;
  let ingredients = ingredientsList.toLowerCase().split(","); // Splitting the ingredients to make an array
  if (language == "fr") {
    ingredients = ingredients.map((ing) => frenchIngrediantsMap[ing]);
  }
  let notesDescriptionData = notesDescription.split(";");
  let ingredientsDescriptionData = ingredientsDescription.split(";");
  let notesDescriptionElement = `<ul class="product-note-description-list">`;
  let ingredientsDescriptionElement = ``;

  ingredients.forEach((element) => {
    const imgSrc = ingredientsData[element];
    const ingredientName = language == "fr" ? elementsTranslation[element] : element;
    main_html_element += `
      <div class="text-center">
        <img class="img-fluid rounded-circle" src="${imgSrc}" alt="${ingredientName}" width="64" height="64">
        <h5 class="text-uppercase">${ingredientName
      }</h5>
      </div>
    `;

    html_element += `
      <div class="text-center">
        <img class="img-fluid rounded-circle" src="${imgSrc}" alt="${ingredientName}" width="96" height="96">
        <h5 class="text-uppercase">${ingredientName}</h5>
      </div>
    `;
  });
  html_element += `</div>`;

  mainIngredientContainer.innerHTML = main_html_element;

  // Adding the Notes Description Header to the HTML element
  if (notesDescriptionHeader) {
    notesDescriptionElement += `<li class="product-note-description-item">${notesDescriptionHeader}</li><br>`;
  }

  // Adding the Notes Description to the HTML element
  for (let i = 0; i < notesDescriptionData.length; i++) {
    switch (i) {
      case 0:
        notesDescriptionElement += `<li class="product-note-description-item"><h4>${language == "fr" ? "NOTE DE TÊTE" : "TOP NOTES"
          }</h4>${notesDescriptionData[i]}</li><br>`;
        break;
      case 1:
        notesDescriptionElement += `<li class="product-note-description-item"><h4>${language == "fr" ? "NOTE DE COEUR" : "MIDDLE NOTES"
          }</h4>${notesDescriptionData[i]}</li><br>`;
        break;
      case 2:
        notesDescriptionElement += `<li class="product-note-description-item"><h4>${language == "fr" ? "NOTE DE FOND" : "BASE NOTES"
          }</h4>${notesDescriptionData[i]}</li><br>`;
        break;
      default:
        notesDescriptionElement += `<li class="product-note-description-item">${notesDescriptionData[i]}</li><br>`;
        break;
    }
  }
  notesDescriptionElement += `</ul>`;
  html_element += notesDescriptionElement;

  ingredientsDescriptionElement += `
  <h4 class="product-popup-header">
  ${ingredientsDescriptionData[0].split(":")[0]}:
  </h4>
  <p class="product-popup-paragraph">${ingredientsDescriptionData[0].split(":")[1]
    }</p>
  
  <h4 class="product-popup-header">
  ${ingredientsDescriptionData[1].split(":")[0]}:
  </h4>
  <p class="product-popup-paragraph">${ingredientsDescriptionData[1].split(":")[1]
    }
 ${ingredientsDescriptionData[1].split(":")[0]}:
</p>
  
  `;
  // detect the website language from the url
  // if the language is french, we add the french description
  // if the language is english, we add the english description
  if (document.URL.search("/fr/") == -1) {
    see_all_ingredients = "SEE ALL INGREDIENTS";
  } else {
    see_all_ingredients = "VOIR LA LISTE D’INGRÉDIENTS";
  }

  html_element += `
<ul style="font-style: normal;
font-size:initial;
text-decoration: underline;
font-weight: 400;
cursor:pointer;"  data-toggle="modal" data-target="#staticBackdrop">
${see_all_ingredients}
</ul>

<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="staticBackdropLabel">${productName}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ${ingredientsDescriptionElement}
      </div>
      </div>
    </div>
  </div>
</div>`;
  ingredientsDiv.innerHTML += html_element;
}
// MKayal end
// Clear the Mega Menu classes

// Mkayal, this is the function that clears the mega menu classes
function clearShowActiveClass() {
  document
    .getElementById("mega-menu-tab-classic")
    .classList.remove("active", "show");
  document
    .getElementById("mega-menu-tab-private")
    .classList.remove("active", "show");
  document
    .getElementById("mega-menu-tab-jour")
    .classList.remove("active", "show");
  document
    .getElementById("mega-menu-tab-refill")
    .classList.remove("active", "show");
}
// show the tabs on hover
// when hovering on the mega menu tabs, show the active class

$("#navbar-top .mega-menu-column .link-hover").hover(function (event) {
  clearShowActiveClass();
  submenuItem = document.querySelector(
    event.target.attributes["mega-menu-link"].value
  );
  submenuItem.classList.add("active", "show");
});
$("#navbar-top .mega-menu-column .link-hover").click(function (event) {
  document.location.href =
    document.location.origin + event.target.attributes["href"].value;
});

// HM side menu arrow flip
$("#slide-out .collapsible-header").on("click", function () {
  $(this)
    .parent()
    .siblings()
    .children()
    .find("span")
    .removeClass("rotate-toggle");
  $(this).find("span").toggleClass("rotate-toggle");
});
// HM end

// HM adding the remove button playground in the discovery set

$(".item-remove-btn").on("click", function () {
  var ThisProductTitle = $(this).siblings("a").html();
  //console.log(ThisProductTitle);
  $(".accordion .product-card .card-body a.title").each(function () {
    if ($(this).html() == ThisProductTitle) {
      //console.log("in if condition");
      $(this).parent().parent().parent().find("button.click-listen").click();
      discoverySetIndex--;
    }
  }); //end loop
  $(this).hide();
});

// FAQ page hover to change css effect buttons
$(".md-accordion .card .faq-btn").hover(
  function () {
    $(this).css({ background: "#000" });
    $(this).find("h5").css({ color: "#fff" });
  },
  function () {
    $(this).css({ background: "#fff" });
    $(this).find("h5").css({ color: "#000" });
  }
);

$("a.box-img").on("click", function () {
  $("#box-include .text").click();
});

// HM detecting the window size to present the Proper vider on the story page

let HVideo = $(".video-desktop");
let VVideo = $(".video-mobile");

if (screen.width < 500) {
  HVideo.addClass("d-none");
  VVideo.removeClass("d-none");
} else {
  HVideo.removeClass("d-none");
  VVideo.addClass("d-none");
}

//HM Check Box in cart item enable

$("#checkOrder")
  .change(function () {
    $("#btncheck").prop("disabled", !this.checked);
  })
  .change();

// Display message after form is submitted

let form = document.getElementById("franchise-form");

form?.addEventListener("submit", function (msg) {
  msg.preventDefault;
  alert("Will be available soon!");
});

/** MG Locale Switch code for snippet (mg_locale-switch.liquid) */
window.addEventListener("load", () => {
  const localeSelectors = document.querySelectorAll(".mg_locale-selector form");
  localeSelectors.forEach((form) => {
    const switchBtns = form.querySelectorAll(".switch-btn");
    switchBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const locale = btn.dataset.locale;
        form.querySelector("input[name='language_code']").value = locale;
        form.submit();
      });
    });
  });
});
/** MG Locale Switch code for snippet (mg_locale-switch.liquid) */
